module.exports = __webpack_public_path__ + "static/img/duofanghuiyi2.5598578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/duofanghuiyi2.png
// module id = S6rY
// module chunks = 24